import { Route, Routes } from 'react-router-dom';
import React from 'react';

import { ShapeAndArea } from '../../components/registering/steps/shapeAndArea';
import { Walls } from '../../components/registering/steps/walls';
import { Windows } from '../../components/registering/steps/windows';
import { Roof } from '../../components/registering/steps/roof';
import Doors from '../../components/registering/steps/doors';
import Floors from '../../components/registering/steps/floors';
import EnergyUsage from '../../components/registering/steps/energyUsage';
import { ConstructionDensity } from '../../components/registering/steps/constructionDensity';

import { OmBoligen } from './pages/omBoligen';
import { Solceller } from './pages/solceller';
import { Oppvarming } from './pages/oppvarming';
import { Ventilasjon } from './pages/ventilasjon';
import { RegistrationLayout } from './registrationLayout';
import { NewRegistrationPage } from './components/newRegistrationPage';
import Energiattest from './pages/energiattest';
import Oppsummering from './pages/oppsummering';
import { JusteringAvVerdier } from './pages/justeringAvVerdier';
import { VisningOgDeling } from './pages/samtykke';
import { ValgfriDetaljering } from './pages/valgfriDetaljering';
import { NewEnergiplanPage } from './components/newEnergiplanPage';

// TODO: Lazy load new components - USER STORY 17524
export const RegistrationRoutes = () => (
  <Routes>
    <Route path="ny/:buildingId/:registrationToCopyId?" element={<NewRegistrationPage />} />
    <Route path="ny-energiplan/:buildingId" element={<NewEnergiplanPage />} />
    <Route path=":registrationId">
      <Route element={<RegistrationLayout />}>
        <Route path="om-boligen" element={<OmBoligen />} />
        <Route path="ventilasjon" element={<Ventilasjon />} />
        <Route path="oppvarming" element={<Oppvarming />} />
        <Route path="detaljering" element={<ValgfriDetaljering />} />
        <Route path="deling" element={<VisningOgDeling />} />
        <Route path="bygningsform" element={<ShapeAndArea />} />
        <Route path="vegger" element={<Walls />} />
        <Route path="vinduer" element={<Windows />} />
        <Route path="solceller" element={<Solceller />} />
        <Route path="takkonstruksjon" element={<Roof displayErrors />} />
        <Route path="ytterdorer" element={<Doors />} />
        <Route path="gulv" element={<Floors />} />
        <Route path="energibruk" element={<EnergyUsage />} />
        <Route path="lekkasjetall" element={<ConstructionDensity />} />
        <Route path="parameter" element={<JusteringAvVerdier />} />
        <Route path="oppsummering" element={<Oppsummering />} />
      </Route>
      <Route path="energiattest" element={<Energiattest />} />
    </Route>
  </Routes>
);
